'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { useGeneratedId } from '../../hooks/useGeneratedId.js';
import '../Radio/Radio.js';
import '../Radio/RadioGroup.js';
import '../Radio/RadioGroupProvider.js';
import { useRadio } from '../Radio/RadioProvider.js';
import { AccessibleRadio } from '../Radio/AccessibleRadio.js';
import { TileButton } from './TileButton.js';

const TileWithRadio = /*#__PURE__*/withTitan(props => {
  const radioProps = useRadio();
  return jsx(TileButton, Object.assign({}, props, radioProps));
}, {
  name: 'TileWithRadio'
});
const Tile = /*#__PURE__*/withTitan((_a, ref) => {
  var {
      id,
      value,
      label,
      description,
      icon,
      isCentered,
      isDisabled,
      hasError,
      onChange,
      labelAria,
      testId = 'tile'
    } = _a,
    rest = __rest(_a, ["id", "value", "label", "description", "icon", "isCentered", "isDisabled", "hasError", "onChange", "labelAria", "testId"]);
  const generatedId = useGeneratedId(id, 'tile');
  return jsx(AccessibleRadio, Object.assign({
    ref: ref,
    id: id || generatedId,
    isDisabled: isDisabled,
    value: value,
    onChange: onChange
  }, rest, {
    children: jsx(TileWithRadio, {
      description: description,
      hasError: hasError,
      isCentered: isCentered,
      label: label,
      labelAria: labelAria,
      labelHtmlFor: id || generatedId,
      testId: testId
    })
  }));
}, {
  name: 'Tile'
});

export { Tile };
//# sourceMappingURL=Tile.js.map
